import Image from 'app/Components/Shared/Image/image';
import React, {useState, useMemo, useEffect} from 'react';
import FilterBar from './FilterBar';
import Pagination from './Pagination';
import BtnBlackBorder from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import {upload} from './Icon/svgIcons';
import Papa from 'papaparse';
import {saveAs} from 'file-saver';
import {isMobile} from 'react-device-detect';
import TableSkeleton from './TableSkeleton';
import './GenericTable.scss';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import CompletedComponent from 'app/Components/Block/IMEIDeviceRepairBlock/Steps/CompletedComponent';
import ErrorMsg from './ErrorMsg';
import FilterChips from './FilterChips';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { createReportIdfNewPlanSignupOrderSummaryPageButtonClicked } from 'app/utilities/reports/createReport';
const GenericTable = ({
  columns,
  data,
  jsonKey,
  onSort,
  totalRecords,
  pagination = false,
  pageSize = 10,
  onLoadMore = null,
  hasMoreData = false,
  showDownloadButton = false,
  getCSVData = null,
  filterOptions,
  isLoading,
  error,
  currentPage,
  setCurrentPage,
  sortConfig,
  setSortConfig,
}) => {
  pageSize = isMobile ? Math.ceil(pageSize/2) : pageSize;
  const totalCount = !isLoading ? totalRecords : pageSize; //for skeleton loading;
  const tableColumns = columns.tableColumns;
  const [expendedRow, setExpendedRow] = useState({});
  const [paginatedData, setPaginatedData] = useState([]);

  const tableWidth = tableColumns.reduce((acc, column) => acc + (column.width || 0), 0);

  useEffect(() => {
    if (!pagination) return data;
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const result = data.slice(startIndex, endIndex);
    setPaginatedData([...result]);
  }, [data, currentPage, pageSize, pagination]);

  const handleSort = (column) => {
    if(column.sortable){
      const newSortConfig = {};
      
      const existingSort = sortConfig[column.sortKey];
      const newDirection = existingSort === 'ASC' ? 'DESC' : 'ASC';
      newSortConfig[column.sortKey] = newDirection;
      
      Object.entries(sortConfig).forEach(([key, value]) => {
        if (key !== column.sortKey) {
          newSortConfig[key] = value;
        }
      });
      
      setSortConfig(newSortConfig);
    }
  };


  const expendOrCollapseRow = (item , column) => {

    var newExpendedRow = {...expendedRow};
    //collapse
    if(newExpendedRow[item.index]){
      newExpendedRow[item.index] = null;
      setExpendedRow(newExpendedRow);
      return;
    }
    //expand
    var data = column.getExpndedData(item , isMobile);

    newExpendedRow[item.index] = data;
    setExpendedRow(newExpendedRow);
  }

  const renderCellContent = (item, column, rowIndex) => {
    var value = '';
    if(column.defaultValue){
      value = column.defaultValue;
    }else if(jsonKey && column.fromJson && item.businessDetails){
      var data = JSON.parse(item.businessDetails);
      if(data && data?.hasOwnProperty(column.key)){
        value = data[column.key];
      }else{
        value = '';
     }
    }else{
      value = item[column.key];
    }
    
    item ={...item,index:rowIndex};     

    switch (column.type) {
      case 'openNewRow':
         const hasExpandedData = column.getExpndedData(item);
         const isExpanded = hasExpandedData && expendedRow[rowIndex];
         const icon = hasExpandedData ? (isExpanded  ? require('./Icon/arrow-up.svg') : require('./Icon/arrow-down.svg')) : null;
         value =  (hasExpandedData && !isMobile) ? value : null;

        return <span className={column.className || ''} onClick={()=>expendOrCollapseRow(item , column)} >{value} {icon && <Image src={icon} alt='arrow' width={16} height={16} />}</span>;
      default:
        return <span className={column.className || ''}>{value}</span>;

    }
  };


  const getDataByScreenMode = (column , dataType  ) => {
    if(isMobile && column.mobileMode){
      return column.mobileMode[dataType];
    }
    return column[dataType];
  }


  return (
    <div className='generic-table-wrapper' style={{width: tableWidth}}>
  
      {(error && !isLoading) ? (
        <ErrorMsg description={error.description} title={error.title} icon={error.icon} />
      ): 
      <div className='generic-table-container' >
        <table className='table table-hover'>
          <thead>
            <tr>
              {tableColumns.map(
                (column, index) =>
                   (!isMobile ||  column.mobileMode) && (
                    <th
                      key={index}
                      style={{width: getDataByScreenMode(column , 'width') }}
                      onClick={() => handleSort(column)}>
                      <div className='th-content'>
                        <div className='column-title'>{getDataByScreenMode(column , 'title')}</div>
                        {column.sortable && <><Image src={require('./Icon/sortingArrow.svg')} alt='sort' className='sort-icon' /></>}
                      </div>
                    </th>
                  )
              )}
            </tr>
          </thead>
          <tbody>
            {isLoading
              ? Array.from({length: pageSize}).map((_, rowIndex) => (
                  <tr key={`skeleton-${rowIndex}`} className='fu-table-row'>
                    {tableColumns.map((column, colIndex) =>(
                      (!isMobile ||  column.mobileMode) && (
                        <td key={colIndex} style={{width: getDataByScreenMode(column , 'width') }}>
                            <Skeleton height={20} width={getDataByScreenMode(column , 'width') * 0.8}/>
                          </td>
                        )
                      )
                    )}
                  </tr>
                ))
              : 
                paginatedData.map((item, rowIndex) => {
                  const rowId = item.id || rowIndex;
                  return (
                    <React.Fragment key={rowId}>
                      <tr className='fu-table-row'>
                        {tableColumns.map((column, colIndex) =>
                        (
                          (!isMobile ||  column.mobileMode) && (
                            <td key={colIndex} className={column.className || ''} style={{width: getDataByScreenMode(column , 'width') }} >
                              {renderCellContent(item, column , rowIndex)}
                            </td>
                          )
                        ) 
                      )}
                      </tr>
                      {expendedRow[rowIndex] && ( 
                        <tr className='expanded-row'>
                          <td colSpan={tableColumns.length}>
                            <div className='expanded-content'>
                              {(() => {
                                try {
                                  const expandedData = JSON.parse(expendedRow[rowIndex]);
                                  return Object.entries(expandedData)
                                    .filter(([key,value]) => !(key.startsWith('_') || isNullOrEmpty(value)))
                                    .map(([key, value], index) => (
                                      <div key={index} className='expanded-item'>
                                        <div className='expanded-key'>{key}</div>
                                        <div className='expanded-value'>{value}</div>
                                      </div>
                                    ));
                                } catch (error) {
                                  return <div className='expanded-error'>Error parsing data</div>;
                                }
                              })()}
                            </div>
                          </td>
                        </tr>
)}
                    </React.Fragment>
                  );
                })}
          </tbody>
        </table>

        <div className='generic-table-footer'>
          {pagination && (
            <Pagination
              totalCount={totalCount}
              pagination={pagination}
              pageSize={pageSize}
              currentPage={currentPage}
              dataToUse={data}
              onPageChange={setCurrentPage}
              hasMoreData={hasMoreData}
              onLoadMore={onLoadMore}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
      }
    </div>
  );
};

export default GenericTable;
